export default "__VITE_ASSET__CcNZZGj8__"